module.exports = __webpack_public_path__ + "img/law3m-m@1.e92f856a.jpg";